
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import GalleryHero from './components/GalleryHero';
import FeaturedShowcase from './components/FeaturedShowcase';
import GalleryGrid from './components/GalleryGrid';
import GalleryCTA from './components/GalleryCTA';

export default function GalleryPage() {
  return (
    <>
      <Navigation />
      <main>
        <GalleryHero />
        <FeaturedShowcase />
        <GalleryGrid />
        <GalleryCTA />
      </main>
      <Footer />
    </>
  );
}
